<template>
<van-nav-bar :title="title" left-text="" :fixed="fixed" :placeholder="fplaceholder" :left-arrow="arrow" @click-left="onBack">
    <template #right v-if="righticon">
        <van-icon name="ellipsis" :size="23" />
    </template>
</van-nav-bar>
</template>

<script>
import {
    NavBar
} from 'vant';
export default {
    name: 'headerNav',
    components: {
        [NavBar.name]: NavBar,
    },
    props: {
        righticon:{
            type: Boolean,
            default: false
        },
        title: String,
        arrow: {
            type: Boolean,
            default: true
        },
        fixed: {
            type: Boolean,
            default: true
        },
        fplaceholder:{
            type: Boolean,
            default: true
        }
    },
    methods: {
        onBack() {
            //history.back();
            this.$router.back()
        },
    }
}
</script>

<style>

</style>
